module.exports = __webpack_public_path__ + "static/img/introduction-sustainability-at-se-hero-lowres.7e76887.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-sustainability-at-se-hero-lowres.jpg
// module id = SH/7
// module chunks = 0